import { type FC, useState } from 'react'
import pluralize from 'pluralize'
import { BulkInviteRowsTable } from './BulkInviteRowsTable'
import { type BulkSeatPreview } from './bulkSeatPreview'

export interface BulkInviteReviewProps {
  preview: BulkSeatPreview
}

export const BulkInviteReview: FC<BulkInviteReviewProps> = ({ preview }) => {
  const allReady = preview.readyCount === preview.rowCount
  const [expanded, setExpanded] = useState(!allReady)

  const readySummary = allReady
    ? `${preview.rowCount} ${pluralize('user', preview.rowCount)} ready`
    : `${preview.readyCount} of ${preview.rowCount} ${pluralize('user', preview.rowCount)} ready`

  return (
    <div className='d-flex flex-column gap-3'>
      <button
        type='button'
        aria-expanded={expanded}
        onClick={() => setExpanded((current) => !current)}
        className='d-flex align-items-center gap-2 w-100 text-start zocks-bg-color-white border zocks-border-color-gray-300 rounded-2 px-3 py-2'
      >
        <i className='bi bi-list zocks-text-gray-900' />
        <span className='paragraph-small zocks-text-gray-900'>
          <span className='bold'>{readySummary}</span> – click to review
        </span>
        <i className='bi bi-chevron-expand zocks-text-gray-600 ms-auto' />
      </button>
      {expanded ? (
        <BulkInviteRowsTable rows={preview.rows.map((previewRow) => ({ row: previewRow.row, status: previewRow.status, errors: previewRow.row.errors }))} />
      ) : null}
    </div>
  )
}
